<style  scoped>

.section__sectors__FixedHeight900
{
    height: 900px;
}

.u-bg--white__Sectors__ValueAdded
{
    background-color: #f2f2f2;
}

.u-bg--white__Sectors__Cybersecurity
{
    background-color: #f2f2f2;
}

</style>

<template>

<div class="c-page u-relative">
  <div class="o-wrapper--panel u-relative u-fit u-fit-w  u-overflow-h">
    <img src="../../assets/medias/images/Sectors/RGH-sectors-First-Arrows-2sections.png" class="o-wrapper--panel u-zindex--1 u-fit u-object-fit-cover">
    <section data-color="clear" class="u-relative u-fit-w  u-overflow-h js-header-panel ">
        <div class="c-page__header o-wrapper--panel" :style="myStylesTransform2">
            <img :src="imageHeadSrc" class="u-absolute u-pos-tl" :style="myStylesWidthHeight">
        </div>
        <div class="o-wrapper--valign u-viewport-fit-h u-fit-w u-zindex--2">
            <div class="u-relative u-inline-block u-valign-bottom u-marg-l-w1of12 u-marg-b-vh1of12 u-marg-b-vh3of12@sm">
              <span class="c-page__subtitle t-h2 t-text--roman u-color--white u-inline-block u-marg-b-md" v-html="content.subtitle"></span>
                <h1 class="t-h2-sub  t-text-lh--md u-color--white u-marg-b-lg">
                    <app-sliced-text :content="content.title"></app-sliced-text>
                </h1>
              </div>
        </div>
    </section>
    <section :data-color="content.blocks[0].dataColor"  class="u-relative u-overflow-h u-fit-w  u-pad-x-w2of12  u-pad-x-w1of12@sm   js-header-panel" :class="[content.blocks[0].bgColorClass]" >
        <div class="c-investors__section u-relative u-flex u-pad-yb0-lg@sm u-flex-fd--column@sm u-pad-y-xxl u-zindex--2" v-if="content.blocks[0].special==='special-left'">
            <div class="u-marg-b-xxl u-marg-b-lg@sm u-w5of8 u-w1of2@md u-marg-l-w1of12@sm u-pad-l-0@lg u-fit-w@sm" :class="{'u-pad-l-w1of8':content.blocks[0].padLeft==='1'}">
                <div>
                  <app-scroll-object :offset=".05" :isParallax="!1" inline-template :content="content.blocks[0]">
                      <div class="w2of10 u-w1of3@md u-fit-w@sm">
                        <h3 class="t-h3 t-text--roman u-relative u-marg-r-lg u-marg-r-0@sm u-color--gray" :class="{'u-color--brand-dark':content.color==='dark','u-color--white':content.color==='white'}">
                            <img src="../../assets/medias/images/lgoRghPart.svg" class="c-logo-Sector-offset3 c-investors__section-2__pattern c-firstslide__whoweare__logo  u-absolute u-pos-bl">
                            <span class="c-number-offset2 t-text--xl--Light u-absolute u-pos-bl" >01</span>
                              <app-words  :isActive="isActive" :delay="0" :content="content.title"></app-words>
                          </h3>
                      </div>
                    </app-scroll-object>
                </div>
                <div :key="indexin" v-for="(itemin, indexin)  in content.blocks[0].content">
                    <h6 class="t-text--xl t-text-lh--md t-text--md u-pad-t-lg" v-if="'title'===itemin.type.value" :class="{'t-text--md--bold':itemin.bold==='true','u-color--brand-dark':itemin.color==='dark','u-color--white':itemin.color==='white','u-color--gray':itemin.color==='gray'}">
                        <app-scroll-object   :offset=".05"  :isParallax="!1" inline-template  :content="itemin" >
                             <app-words  :isActive="isActive" :delay="0" :content="content.content"></app-words>
                         </app-scroll-object >
                      </h6>
                    <div class="u-marg-t-md t-text--md" v-if=" 'default'===itemin.type.value" :class="{'u-marg-t-md':indexin>0,'u-color--gray':itemin.color==='dark','u-color--white':itemin.color==='white'}" v-html="itemin.content"> </div>

                  </div>
            </div>
        </div>
    </section>
  </div>
    <section v-if="index>0" :data-color="item.dataColor" v-for="(item, index)  in content.blocks" class="u-relative u-overflow-h u-fit-w  u-pad-x-w2of12  u-pad-x-w1of12@sm   js-header-panel" :class="[item.bgColorClass]" >
    <div v-if="index===1" class="c-page__header o-wrapper--panel " :style="myStylesTransform2">
            <img src="../../assets/medias/images/Sectors/RGH-Sectors-SecondShip.jpg" class="u-absolute u-pos-tl u-fit u-object-fit-cover " :style="myStylesWidthHeight">
        </div>
        <!--<div v-if="index===2" class="u-absolute u-pos-tr" >
            <img src="../../assets/medias/images/Sectors/RGH-sectors-Security.png" class="u-fit ">
        </div>
        <div v-if="index===3" class="u-absolute u-pos-tl u-fit">
            <div class="c-investors__section-2__pattern u-absolute u-pos-y-center  u-pos-tr  u-w2 of10 u-marg-b-0@sm u-opacity--10@sm">
                <img src="../../assets/medias/images/Sectors/Value-right-Arrows.png" class="u-fit-w">
            </div>
        </div>-->

        <div v-if="index===2" class="c-page__header o-wrapper--panel " :style="myStylesTransform2">
                <img src="../../assets/medias/images/Sectors/RGH-Security-Printing.jpg" class="u-absolute u-pos-tl u-fit u-object-fit-cover  u-opacity--74@sm" :style="myStylesWidthHeight">
            </div>
        <!--<div v-if="index===2" class="u-absolute u-pos-br u-opacity--40@sm" style="bottom:-20px;">
          <img src="../../assets/medias/images/Sectors/RGH-sectors-Security.png" class="u-fit">
        </div>-->
        <div v-if="index===3" class="u-absolute u-pos-tr u-opacity--40@sm">
          <img src="../../assets/medias/images/Sectors/Value-right-Arrows.png" class="u-fit">
        </div>
        <div v-if="index===4" class="u-absolute u-pos-br u-opacity--20@sm" style="bottom:-20px;">
          <img src="../../assets/medias/images/Sectors/CyberSecurity-Rgh.jpg" class="u-fit">
        </div>
        <div v-if="index===5" class="u-absolute u-pos-br u-opacity--30@sm">
          <img src="../../assets/medias/images/Sectors/Rgh-secure-communicatino-barrs.png" class="u-fit">
        </div>
        <div v-if="index===6" class="u-absolute u-pos-tr u-opacity--30@sm">
          <img src="../../assets/medias/images/Sectors/telecomInfrastructur-right.png" class="u-fit">
        </div>
        <div v-if="index===7" class="u-absolute u-pos-br u-opacity--20@sm" style="bottom:-5px;right:0px">
          <img src="../../assets/medias/images/Sectors/Election-Supply-Chain-Rgh.png" class="u-fit">
        </div>
        <div v-if="index===8" class="u-absolute u-pos-br u-opacity--20@sm" style="bottom:-5px;right:0px">
          <img src="../../assets/medias/images/Sectors/Election-Supply-Chain-Rgh.png" class="u-fit">
        </div>
        <div v-if="index===9" class="u-absolute u-pos-tr u-opacity--10@sm" style="z-index: 1;" >
          <img src="../../assets/medias/images/Sectors/Lotary-Operations-Rgh.png" class="u-fit">
        </div>
        <div v-if="index===9" class="c-page__header o-wrapper--panel u-opacity--10@sm u-opacity--20@lg" :style="myStylesTransform2">
            <img src="../../assets/medias/images/Sectors/Rgh-Operation-Vote.jpg" class="u-fit" :style="myStylesWidthHeight">
        </div>
        <div v-if="index===10" class="u-absolute u-pos-bl u-opacity--40@sm" >
          <img src="../../assets/medias/images/Sectors/Mobile-and-VirtualGames.png" class="u-fit">
        </div>
        <span v-if="index<content.blocks.length -1" class="c-line c-line--x u-absolute u-pos-bl u-bg--gray u-fit-w"></span>

          <div class="c-investors__section u-relative u-flex u-pad-yb0-lg@sm u-flex-fd--column@sm u-pad-y-xxl u-zindex--2" v-if="item.special==='special-left'">
            <div class="u-marg-b-xxl u-marg-b-lg@sm u-w5of8 u-w1of2@md u-marg-l-w1of12@sm u-pad-l-0@lg u-fit-w@sm" :class="{'u-pad-l-w1of8':item.padLeft==='1'}">
                <div>
                  <app-scroll-object :offset=".05" :isParallax="!1" inline-template :content="item">
                        <h3 class="t-h3 t-text--roman u-relative u-marg-r-lg   u-marg-r-0@sm" :class="{'u-color--brand-dark':item.color==='dark','u-color--white':item.color==='white'}">
                            <img src="../../assets/medias/images/lgoRghPart.svg" class="c-logo-Sector-offset2 c-investors__section-2__pattern c-firstslide__whoweare__logo  u-absolute u-pos-bl" v-if="index===0">
                            <span class="c-number-offset2 t-text--xl--Light  u-absolute u-pos-bl" >{{index+1<10?"0"+(index+1):index+1}}</span>
                              <app-words  :isActive="isActive" :delay="0" :content="content.title"></app-words>
                          </h3>
                    </app-scroll-object>
                </div>
                <div :key="indexin" v-for="(itemin, indexin)  in item.content">
                    <h6 class="t-text--xl t-text-lh--md t-text--md u-pad-t-lg" v-if="'title'===itemin.type.value" :class="{'t-text--md--bold':itemin.bold==='true','u-color--brand-dark':itemin.color==='dark','u-color--white':itemin.color==='white','u-color--gray':itemin.color==='gray'}">
                        <app-scroll-object   :offset=".05"  :isParallax="!1" inline-template  :content="itemin" >
                             <app-words  :isActive="isActive" :delay="0" :content="content.content"></app-words>
                         </app-scroll-object >
                      </h6>
                    <div class="u-marg-t-md t-text--md" v-if=" 'default'===itemin.type.value" :class="{'u-marg-t-md':indexin>0,'u-color--gray':itemin.color==='dark','u-color--white':itemin.color==='white'}" v-html="itemin.content"> </div>

                  </div>
            </div>
        </div>
    </section>
    <app-footer :globalContent="globalContent" :adminContent="adminContent"></app-footer>
</div>

</template>

<script>

import AppFooter from '../app-footer/index.vue'
import AppScrollObject from '../app-scroll-object/index.vue'
import AppSlicedText from '../app-sliced-text/index.vue'
import AppRiskTools from '../app-sliced-text/index.vue'
export default {
    props: {
      debug: {
          type: Boolean,
          default: !1
      },
        adminContent: {
            type: Object,
            default: function() {}
        },
        globalContent: {
            type: Object,
            default: function() {}
        },
        headerPageSize: {
            type: Array,
            default: function() {}
        }
    },
    components: {
        "app-footer": AppFooter,
        "app-scroll-object": AppScrollObject,

        "app-sliced-text": AppSlicedText,
        "app-risk-tools": AppRiskTools
    },
    computed: {
        content: function() {
            return this.adminContent.en.pages.sectors
        },
        myStylesTransform2() {
            return {
                transform: 'translateX(' + this.headerPageSize[2] + 'px) translateY(' + this.headerPageSize[3] + 'px) scale(' + this.headerPageSize[4] + ')'

            }

        },
        myStylesWidthHeight() {
            return {
                width: this.headerPageSize[0] + "px",
                height: this.headerPageSize[1] + "px"

            }
        },
        myStylesWidthHeight11() {
            return {
                width: "1600px",
                height: "900px"

            }
        }
    },
    created: function() {
        this.eventHub.$on("resize", this.onResize)
    },
    destroyed: function() {
        this.eventHub.$off("resize", this.onResize)
    },
    mounted: function() {

        this.onResize(),
            this.eventHub.$emit("page:ready")
    },
    data: function() {
        return {

            imageHeadSrc: require('../../assets/medias/images/Sectors/New-RGh-Sectors-header.jpg')

        }
    },
    methods: {
        onResize: function() {}
    }

}

</script>



// WEBPACK FOOTER //
// src/components/app-page-sectors/index.vue